import * as THREE from "three";

// Mutable, non-reactive game state read/written every animation frame.
export const gameState = {
  position: new THREE.Vector3(0, 0, 20),
  facing: Math.PI,
  cameraYaw: Math.PI,
  moving: false,
};
